import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/core/services/session.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { SettingsReturnUrlService } from 'src/app/core/services/settings-return-url.service';

@Component({
  selector: 'app-settings-sidebar',
  templateUrl: './settings-sidebar.component.html',
  styleUrls: ['./settings-sidebar.component.scss']
})
export class SettingsSidebarComponent implements OnInit {

  toggleUserSettings!: boolean;
  toggleTeamManagement!: boolean;
  toggleCompanySettings!: boolean;
  toggleSidebar!: boolean;

  constructor(
    private router: Router,
    private readonly sessionService: SessionService,
    private readonly store: Store<AppState>,
    private readonly settingsReturnUrlService: SettingsReturnUrlService,
  ) { }

  ngOnInit(): void {
  }

  toggle(type: string) {
    switch (type) {
      case 'userSettings':
        this.toggleUserSettings = !this.toggleUserSettings;
        break;
      case 'teamManagement':
        this.toggleTeamManagement = !this.toggleTeamManagement;
        break;
      case 'companySettings':
        this.toggleCompanySettings = !this.toggleCompanySettings;
        break;
    }
  }

  goBack() {
    // Returns to wherever the user came from, falling back to the orders list.
    // Previously this always went to /inventory (the products page).
    this.router.navigateByUrl(this.settingsReturnUrlService.returnUrl);
  }

  logout() {
    // Revokes the session server-side as well as locally — see SessionService.
    this.sessionService.logout();
  }
}
